import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { LoginResult, UserProfile } from '@/api/account'
import { doLogout } from '@/api/account'

const useAccountStore = defineStore('account', () => {
  const token = ref('')
  const user_profile = ref<UserProfile>({} as UserProfile)
  const saved_accounts = ref<Array<{identifier: string, username: string, hasBiometric: boolean}>>([])

  function setToken(value: string) {
    token.value = value
  }

  function setUserInfo(value: any) {
    token.value = value.token
  }

  function setUserProfile(value: UserProfile) {
    user_profile.value = value
    // 更新或添加账号到已保存账号列表
    const existingAccount = saved_accounts.value.find(acc => acc.identifier === value.email)
    if (existingAccount) {
      // 更新现有账号信息
      existingAccount.username = value.username
      existingAccount.hasBiometric = value.hasBiometric
      // 将当前账号移到列表最前面
      saved_accounts.value = [
        existingAccount,
        ...saved_accounts.value.filter(acc => acc.identifier !== value.email)
      ]
    } else {
      // 添加新账号到列表最前面
      saved_accounts.value.unshift({
        identifier: value.email,
        username: value.username,
        hasBiometric: value.hasBiometric
      })
    }
  }

  function logout() {
    token.value = ''
    user_profile.value = {} as UserProfile
  }

  return {
    token,
    user_profile,
    saved_accounts,
    setToken,
    setUserInfo,
    setUserProfile,
    logout
  }
}, {
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'account-store',
        storage: localStorage,
        paths: ['token', 'user_profile', 'saved_accounts']
      }
    ]
  }
})

export const account = useAccountStore
export default useAccountStore
